import Form from 'components/Form';
import {
  Box,
  TableBody,
  TableHead,
  TableRow,
  TableContainer,
} from '@mui/material';
import {
  StyledTableCellTwo,
  StyledTableCellWithoutLeftTwo,
} from 'routes/Main/style';
import SectionTitle from '../../components/SectionTitle';

import { IFormValues, IFormWatch, IFormRegister } from 'routes/Main/type';

const contentLabel = [
  {
    id: 1,
    ko: '얼굴표정',
    desc: '이완됨, 자연스러움',
    desc1: '긴장됨',
    desc2: '인상을 찌푸림',
    keyName: 'face_cpot',
  },
  {
    id: 2,
    ko: '신체운동',
    desc: '움직임이 없거나 정상 자세',
    desc1: '보호',
    desc2: '불안정',
    keyName: 'body_cpot',
  },
  {
    id: 3,
    ko: '발성',
    desc: '보통의 어조로 말하거나 소리 내지 않음',
    desc1: '한숨, 신음',
    desc2: '소리내어 울거나 흐느낌',
    keyName: 'voice_cpot',
  },
  {
    id: 4,
    ko: '근육 긴장도',
    desc: '이완됨',
    desc1: '긴장됨, 경직됨',
    desc2: '매우 긴장되거나 경직됨',
    keyName: 'muscle_cpot',
  },
  {
    id: 5,
    ko: '총점',
    desc: '',
    desc1: '',
    desc2: '',
    keyName: '',
  },
];

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
}
const CPOT_K = (props: Props) => {
  const { disabled, setValue, getValues, register, watch } = props;

  // CPOT-K
  const 얼굴표정01 = props.watch('face_cpot01')
    ? Number(props.watch('face_cpot01'))
    : 0;
  const 신체운동01 = props.watch('body_cpot01')
    ? Number(props.watch('body_cpot01'))
    : 0;
  const 발성01 = props.watch('voice_cpot01')
    ? Number(props.watch('voice_cpot01'))
    : 0;
  const 근육01 = props.watch('muscle_cpot01')
    ? Number(props.watch('muscle_cpot01'))
    : 0;

  const 얼굴표정02 = props.watch('face_cpot02')
    ? Number(props.watch('face_cpot02'))
    : 0;
  const 신체운동02 = props.watch('body_cpot02')
    ? Number(props.watch('body_cpot02'))
    : 0;
  const 발성02 = props.watch('voice_cpot02')
    ? Number(props.watch('voice_cpot02'))
    : 0;
  const 근육02 = props.watch('muscle_cpot02')
    ? Number(props.watch('muscle_cpot02'))
    : 0;

  const 얼굴표정03 = props.watch('face_cpot03')
    ? Number(props.watch('face_cpot03'))
    : 0;
  const 신체운동03 = props.watch('body_cpot03')
    ? Number(props.watch('body_cpot03'))
    : 0;
  const 발성03 = props.watch('voice_cpot03')
    ? Number(props.watch('voice_cpot03'))
    : 0;
  const 근육03 = props.watch('muscle_cpot03')
    ? Number(props.watch('muscle_cpot03'))
    : 0;

  const 총점1 = 얼굴표정01 + 신체운동01 + 발성01 + 근육01;

  const 총점2 = 얼굴표정02 + 신체운동02 + 발성02 + 근육02;

  const 총점3 = 얼굴표정03 + 신체운동03 + 발성03 + 근육03;

  return (
    <>
      <SectionTitle title="CPOT-K" mt={3} mb={2} />
      <Box sx={{ width: '98%', margin: '20px' }}>
        <TableContainer>
          <TableHead>
            <TableRow>
              <StyledTableCellTwo
                colSpan={1}
                sx={{
                  padding: '16px',
                  borderTop: '1px solid lightgray',
                  fontSize: '12px',
                }}
              ></StyledTableCellTwo>
              <StyledTableCellTwo
                colSpan={1}
                sx={{ borderTop: '1px solid lightgray', fontSize: '12px' }}
              >
                0점
              </StyledTableCellTwo>
              <StyledTableCellTwo
                colSpan={1}
                sx={{
                  borderTop: '1px solid lightgray',
                  fontSize: '12px',
                }}
              >
                1점
              </StyledTableCellTwo>
              <StyledTableCellTwo
                colSpan={1}
                sx={{
                  borderTop: '1px solid lightgray',
                  fontSize: '12px',
                }}
              >
                2점
              </StyledTableCellTwo>
              <StyledTableCellTwo
                colSpan={1}
                align="center"
                sx={{
                  borderTop: '1px solid lightgray',
                  paddingLeft: '30px',
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                입실
                <br />
                5분이내
              </StyledTableCellTwo>
              <StyledTableCellTwo
                colSpan={1}
                align="center"
                sx={{
                  borderTop: '1px solid lightgray',
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                입실
                <br />
                5분이후
              </StyledTableCellTwo>
              <StyledTableCellTwo
                colSpan={1}
                align="center"
                sx={{
                  borderTop: '1px solid lightgray',
                  fontSize: '12px',
                  fontWeight: 500,
                }}
              >
                입실 or
                <br />
                중재
                <br />
                30분후
              </StyledTableCellTwo>
            </TableRow>
          </TableHead>

          <TableBody>
            {contentLabel.map(
              (
                content: {
                  id: number;
                  ko: string;
                  desc: string;
                  desc1: string;
                  desc2: string;
                  keyName: string;
                },
                i
              ) => {
                if (content.ko === '총점') {
                  return (
                    <TableRow>
                      <StyledTableCellTwo
                        align="left"
                        sx={{
                          padding: '16px',
                          width: '150px',
                          whiteSpace: 'nowrap',
                          fontSize: '12px',
                        }}
                      >
                        {content.ko}
                      </StyledTableCellTwo>
                      <StyledTableCellTwo
                        align="left"
                        sx={{
                          width: '1000px',
                          whiteSpace: 'nowrap',
                          fontSize: '12px',
                        }}
                      >
                        {content.desc}
                      </StyledTableCellTwo>
                      <StyledTableCellTwo
                        align="left"
                        sx={{
                          width: '1000px',
                          whiteSpace: 'nowrap',
                          fontSize: '12px',
                        }}
                      >
                        {content.desc1}
                      </StyledTableCellTwo>
                      <StyledTableCellTwo
                        align="left"
                        sx={{
                          width: '1000px',
                          whiteSpace: 'nowrap',
                          fontSize: '12px',
                        }}
                      >
                        {content.desc2}
                      </StyledTableCellTwo>
                      <StyledTableCellWithoutLeftTwo>
                        <Form.MuiTextField
                          disabled={disabled}
                          sx={{ width: '80px', marginLeft: '30px' }}
                          value={총점1}
                        />
                      </StyledTableCellWithoutLeftTwo>
                      <StyledTableCellWithoutLeftTwo>
                        <Form.MuiTextField
                          disabled={disabled}
                          sx={{ width: '80px', margin: '0 30px 0 30px' }}
                          value={총점2}
                        />
                      </StyledTableCellWithoutLeftTwo>
                      <StyledTableCellWithoutLeftTwo>
                        <Form.MuiTextField
                          disabled={disabled}
                          sx={{ width: '80px' }}
                          value={총점3}
                        />
                      </StyledTableCellWithoutLeftTwo>
                    </TableRow>
                  );
                }

                return (
                  <TableRow>
                    <StyledTableCellTwo
                      align="left"
                      sx={{
                        padding: '16px',
                        width: '150px',
                        whiteSpace: 'nowrap',
                        fontSize: '12px',
                      }}
                    >
                      {content.ko}
                    </StyledTableCellTwo>
                    <StyledTableCellTwo
                      align="left"
                      sx={{
                        width: '150px',
                        whiteSpace: 'nowrap',
                        fontSize: '12px',
                      }}
                    >
                      {content.desc}
                    </StyledTableCellTwo>
                    <StyledTableCellTwo
                      align="left"
                      sx={{
                        width: '270px',
                        whiteSpace: 'nowrap',
                        fontSize: '12px',
                      }}
                    >
                      {content.desc1}
                    </StyledTableCellTwo>
                    <StyledTableCellTwo
                      align="left"
                      sx={{
                        width: '540px',
                        whiteSpace: 'nowrap',
                        fontSize: '12px',
                      }}
                    >
                      {content.desc2}
                    </StyledTableCellTwo>
                    <StyledTableCellWithoutLeftTwo>
                      <Form.MuiTextField
                        required={false}
                        disabled={disabled}
                        sx={{ width: '80px', marginLeft: '30px' }}
                        type="number"
                        {...register(`${content.keyName}01`, {
                          onChange: e => {
                            if (e.target.value > 2) {
                              alert('0-2까지 입력할 수 있습니다.');
                              setValue(`${content.keyName}01`, 0);
                            }
                            if (e.target.value < 0) {
                              alert('음수는 불가능합니다.');
                              setValue(`${content.keyName}01`, 0);
                            }
                            setValue(
                              `${content.keyName}01`,
                              Number(e.target.value)
                            );
                          },
                        })}
                      />
                    </StyledTableCellWithoutLeftTwo>
                    <StyledTableCellWithoutLeftTwo>
                      <Form.MuiTextField
                        required={false}
                        disabled={disabled}
                        sx={{ width: '80px', margin: '0 30px 0 30px' }}
                        type="number"
                        {...register(`${content.keyName}02`, {
                          onChange: e => {
                            if (e.target.value > 2) {
                              alert('0-2까지 입력할 수 있습니다.');
                              setValue(`${content.keyName}02`, 0);
                            }
                            if (e.target.value < 0) {
                              alert('음수는 불가능합니다.');
                              setValue(`${content.keyName}02`, 0);
                            }
                            setValue(
                              `${content.keyName}02`,
                              Number(e.target.value)
                            );
                          },
                        })}
                      />
                    </StyledTableCellWithoutLeftTwo>
                    <StyledTableCellWithoutLeftTwo>
                      <Form.MuiTextField
                        required={false}
                        disabled={disabled}
                        sx={{ width: '80px' }}
                        type="number"
                        {...register(`${content.keyName}03`, {
                          onChange: e => {
                            if (e.target.value > 2) {
                              alert('0-2까지 입력할 수 있습니다.');
                              setValue(`${content.keyName}03`, 0);
                            }
                            if (e.target.value < 0) {
                              alert('음수는 불가능합니다.');
                              setValue(`${content.keyName}03`, 0);
                            }
                            setValue(
                              `${content.keyName}03`,
                              Number(e.target.value)
                            );
                          },
                        })}
                      />
                    </StyledTableCellWithoutLeftTwo>
                  </TableRow>
                );
              }
            )}
          </TableBody>
        </TableContainer>
      </Box>
    </>
  );
};

export default CPOT_K;
